module.exports = __webpack_public_path__ + "img/icon_replay1.9a6a5c6e.png";